export default "__VITE_ASSET__ym1C2eN7__"